import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Check, Loader2, ArrowRight } from "lucide-react";
import { API_URL } from "../data/site";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setState("unknown");
      return;
    }
    let timer;
    const poll = async () => {
      try {
        const res = await axios.get(`${API_URL}/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch {
        /* keep polling */
      }
      attempts.current += 1;
      if (attempts.current < 15) {
        timer = setTimeout(poll, 2000);
      } else {
        setState("pending");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="flex min-h-screen items-center bg-white pt-20">
      <div className="mx-auto max-w-xl px-5 py-24 text-center">
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto h-8 w-8 animate-spin text-[#e63946]" />
            <h1 className="font-display mt-6 text-3xl font-extrabold tracking-tight text-[#111111]">
              Confirming your payment…
            </h1>
          </>
        )}
        {state === "paid" && (
          <>
            <span className="mx-auto flex h-14 w-14 items-center justify-center bg-[#111111]">
              <Check className="h-6 w-6 text-[#e63946]" />
            </span>
            <h1 className="font-display mt-6 text-4xl font-extrabold tracking-tight text-[#111111]">
              Payment confirmed.
            </h1>
            <p className="mt-4 text-base leading-relaxed text-neutral-600">
              Thank you — your payment went through. The ABS LLC team will
              contact you within one business day to schedule your program.
            </p>
          </>
        )}
        {(state === "pending" || state === "unknown") && (
          <>
            <h1 className="font-display mt-6 text-3xl font-extrabold tracking-tight text-[#111111]">
              We're confirming your payment.
            </h1>
            <p className="mt-4 text-base leading-relaxed text-neutral-600">
              This can take a moment. If you completed checkout, you're all set —
              the team will confirm by email shortly.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="payment-success-home-link"
          className="group mt-8 inline-flex items-center gap-2 bg-[#111111] px-7 py-4 text-[13px] font-semibold uppercase tracking-[0.16em] text-white transition-colors duration-300 hover:bg-[#e63946]"
        >
          Back to ABS LLC
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
    </div>
  );
}
